import { Component } from '@angular/core';
import { WorkflowDialogContent } from '../../../workflow.dialog';
import { WorkflowType } from '../../../../models/enums/workflowtype.enum';
import { WorkflowExitInfo, WorkflowModuleSettingsHelper, WorkflowRegistry } from '../../../../services/workflow.service';
import { WorkflowModuleExecuter, WorkflowStatus } from '../../../../models/workflow/workflow.model';
import { ClassTransformerHelper } from '../../../../helpers/class.transformer.helper';

@Component({
    selector: 'get-scroll-position-settings',
    templateUrl: './get.scroll.position.settings.html'
})
export class GetScrollPositionSettings extends WorkflowDialogContent {
    Data = new GetScrollPositionSettingsData();

    constructor() {
        super();
        this.HasExpressions = true;
    }

    public static GetRegistry(): WorkflowRegistry {
        const reg = new WorkflowRegistry();
        reg.ID = 'getScrollPositionModule';
        reg.Caption = '@@GetScrollPosition';
        reg.GroupID = 'layout';
        reg.Index = 57;
        reg.SettingsControl = GetScrollPositionSettings;
        reg.SettingsTypeHelper = new GetScrollPositionSettingsDataHelper();
        reg.Executer = GetScrollPositionModuleExecuter;
        reg.WorkflowType = WorkflowType.Client;
        return reg;
    }

    initialize(data: any) {
        if (data) {
            this.Data = ClassTransformerHelper.CopyObject(data, GetScrollPositionSettingsData);
        }
    }

    getResult(): any {
        return this.Data;
    }

    GetExpressionProperties() {
        return [{
            Value: 'ElemName'
        }];
    }
}

export class GetScrollPositionSettingsData {
    ElemName: string;
    StatusKey: string;
    UseForState = false;
}

export class GetScrollPositionSettingsDataHelper extends WorkflowModuleSettingsHelper {

    getEmptySettingsInstance() {
        return new GetScrollPositionSettingsData();
    }

    getAdditionalCaption(settings) {
        if (settings && settings.ElemName) {
            return settings.ElemName;
        }
        return super.getAdditionalCaption(settings);
    }

    getExitPoints(settings): WorkflowExitInfo[] {
        return [new WorkflowExitInfo()];
    }

    changeSettingsOnElementNameChange(settings: any, oldName: string, newName: string): boolean {
        if (settings && settings.ElemName === oldName) {
            settings.ElemName = newName;
            return true;
        }
        return false;
    }

    async fillActualState(module, state, wfData) {
        if (state) {
            const settings = WorkflowModuleSettingsHelper.GetSettingsFromModule(module);
            if (settings && settings.StatusKey) {
                WorkflowModuleSettingsHelper.AddStatusKeysToState(state, [settings.StatusKey]);
            }
        }
    }
}

export class GetScrollPositionModuleExecuter extends WorkflowModuleExecuter {
    async execute(status: WorkflowStatus): Promise<number> {
        if (status.ActualSettings) {
            if (typeof status.ActualSettings.ElemName === 'string') {
                const elem = status.WorkflowLayoutService.getElementByName(status.ActualSettings.ElemName);
                if (elem) {
                    const htmlelem = document.getElementById('LE_Scroll_' + elem.ID) ?? document.getElementById('LE_' + elem.ID);
                    if (htmlelem) {
                        const val = {
                            X: htmlelem.scrollLeft,
                            Y: htmlelem.scrollTop
                        };
                        if (status.ActualSettings.StatusKey) {
                            status.Context.set(status.ActualSettings.StatusKey, val);
                        }
                        if (status.ActualSettings.UseForState) {
                            status.ActualParameter = val;
                        }
                        return 0;
                    } else {
                        status.Logger.logError('GetScrollPosition modul: HTML Element not found.');
                    }
                } else {
                    status.Logger.logError('GetScrollPosition modul: Element not found.');
                }
            } else {
                status.Logger.logError('GetScrollPosition modul: No element name found.');
            }
        } else {
            status.Logger.logError('GetScrollPosition modul: No settings found.');
        }
        return super.execute(status);
    }
}
